<!-- Right Sidebar -->

<div class="right-bar">

  <ngx-simplebar class="h-100">
    <div class="rightbar-title px-3 py-4">
      <a href="#" (click)="$event.preventDefault(); hide()" class="right-bar-toggle float-end">
        <i class="mdi mdi-close noti-icon"></i>
      </a>
      <h5 class="m-0">Settings</h5>

      <h6 class="mt-4 mb-3">Theme Mode</h6>
      <hr />
      <div class="form-check sidebar-setting">
        <input class="form-check-input" type="radio" name="theme-color" id="theme-color-light" [checked]="mode === 'light'" (change)="changeMode('light')">
        <label class="form-check-label" for="theme-color-light">Light</label>
      </div>
      <div class="form-check sidebar-setting">
        <input class="form-check-input" type="radio" name="theme-color" id="theme-color-dark" [checked]="mode === 'dark'" (change)="changeMode('dark')">
        <label class="form-check-label" for="theme-color-dark">Dark</label>
      </div>

      <!-- Language selector hidden - only English is currently supported
      <h6 class="mt-4 mb-3">Language</h6>
      <hr />
      @for (item of listLang; track $index) {
      <div class="form-check">
        <input class="form-check-input" type="radio" name="language" [id]="'lang-' + item.lang" [checked]="cookieValue === item.lang" (change)="setLanguage(item.text, item.lang, item.flag)">
        <label class="form-check-label" [for]="'lang-' + item.lang">
          <img src="{{item.flag}}" alt="{{item.text}}" class="me-2" height="12">
          {{item.text}}
        </label>
      </div>
      }
      -->
    </div>
  </ngx-simplebar>
</div>
<!-- /Right-bar -->

<!-- Right bar overlay-->
<div class="rightbar-overlay" (click)="hide()"></div>